<template>
  <div>
    <div class="row-block already-worked">
      <div>{{ $tr('responses.resume.alreadyWorked') }}</div>
      <div>{{ alreadyWorked ? $tr('responses.resume.yes') : $tr('responses.resume.no') }}</div>
    </div>
    <div class="row-block cv-link">
      <div>{{ $tr('responses.resume.cvLink') }}</div>
      <div>
        <CVLink v-if="cvLink" :link="cvLink"/>
      </div>
    </div>
  </div>
</template>

<script>
import CVLink from '@/components/shared/CVLink.vue'
import MixinState from '../../../mixins/state.js'

export default {
  name: 'process-response-resume-additional-info',

  components: {
    CVLink
  },

  mixins: [
    MixinState
  ],

  computed: {
    process () {
      return this.storeResponseSingleDataProcess
    },

    alreadyWorked () {
      return this.process ? this.process.already_worked : false
    },

    cvLink () {
      return this.process ? this.process.cv_link : null
    }
  }
}
</script>

<style lang="scss" scoped>
  .row-block {
    margin-bottom: 20px;
    display: flex;

    & > div {
      width: 66%;
    }
    & > div:first-child {
      font-weight: bold;
      width: 33%;
    }
  }
</style>
